import { useMemo } from 'react';
import { useTheme, SxProps } from '@mui/material';
import { StylesType } from '../types/style.types';
import { commonStyles } from '../../components/common-styles';

/**
 * @deprecated Has been moved to shared library
 */
export const useStyles = <
	StyleType extends StylesType,
	Result = ReturnType<StyleType>,
	CommonType = ReturnType<typeof commonStyles>,
	Both = Result & CommonType
>(
	styleFunc?: StyleType,
	...styleDeps: unknown[]
): Both => {
	const theme = useTheme();

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const styles = useMemo<Both>(
		() =>
			({
				...(commonStyles(theme) as unknown as CommonType),
				...(styleFunc?.(theme, ...styleDeps) as unknown as Result),
			} as unknown as Both),
		[styleDeps, styleFunc, theme]
	);

	return styles as Both;
};

/**
 * @deprecated Has been moved to shared library
 */
export const clsx = (...styles: SxProps[]): SxProps => Object.assign({}, ...styles);
